import React from 'react'
import { twMerge } from 'tailwind-merge'
import { FormLayoutEnum } from 'src/shared/types/entities/form-interface'
import { LayoutSwitcherButton } from './form-layout-switcher-button'
import {
  DarkLayoutSwitcherButtonLine,
  LightLayoutSwitcherButtonLine,
} from './form-layout-switcher-button-line'

export interface FormLayoutSwitcherProps {
  className?: string
  value: FormLayoutEnum
  update: (value: FormLayoutEnum) => void
}

export const FormLayoutSwitcher = ({
  className,
  update,
  value,
}: FormLayoutSwitcherProps) => {
  const handleButtonClick = (value: FormLayoutEnum) => {
    update(value)
  }
  return (
    <div
      className={twMerge(
        'flex w-full gap-2 rounded-xl bg-bgSecondary p-1.5',
        className,
      )}
    >
      <LayoutSwitcherButton
        active={value === FormLayoutEnum.OneColumn}
        onClick={() => handleButtonClick(FormLayoutEnum.OneColumn)}
        className={'grid-cols-1'}
      >
        <LightLayoutSwitcherButtonLine className="min-w-22.5" />
        <LightLayoutSwitcherButtonLine className="min-w-22.5" />
        <DarkLayoutSwitcherButtonLine className="min-w-22.5" />
      </LayoutSwitcherButton>
      <LayoutSwitcherButton
        active={value === FormLayoutEnum.TwoColumns}
        onClick={() => handleButtonClick(FormLayoutEnum.TwoColumns)}
        className={'grid-cols-2'}
      >
        <LightLayoutSwitcherButtonLine />
        <LightLayoutSwitcherButtonLine />
        <LightLayoutSwitcherButtonLine />
        <LightLayoutSwitcherButtonLine />
        <DarkLayoutSwitcherButtonLine />
      </LayoutSwitcherButton>
    </div>
  )
}
